const contactContent = {
  mobile: {
    title: "Call Us",
    logo: "/images/icon/contact-us/mobile-app-icon.webp",
    content: "+63-2-8-6263222",
    qrCode: "/images/qr-code/phoneqr.webp",
  },
  viber: {
    title: "Viber Support",
    logo: "/images/icon/contact-us/viber-app-icon.webp",
    content: "+855-969-845-661",
    qrCode: "/images/qr-code/new-viberqr.webp",
  },
  telegram: {
    title: "Telegram Channel",
    logo: "/images/icon/social-media/telegram.webp",
    content: "@FUNGAMINGHUB",
    qrCode: "/images/qr-code/tgqr-enhanced.webp",
  },
}

export default function ContactUs({ type, types, onClose }) {
  const selectedTypes = types || (type ? [type] : [])

  const contacts = selectedTypes
    .map((contactType) => ({
      type: contactType,
      ...contactContent[contactType],
    }))
    .filter((contact) => contact.qrCode)

  if (!contacts.length) return null

  return (
    <div className="fgh-contact-us-container fgh-contact-container">
      <div className="fgh-contact-us-container--content fgh-contact-content">
        <div className="fgh-contact-list fgh-contact-content-list">
          {contacts.map(({ type, title, content, qrCode, logo }) => (
            <div className="fgh-contact-card fgh-card" key={type}>
              <div className="fgh-contact-logo fgh-logo">
                <img src={logo} alt={title} />
              </div>

              <h3>{title}</h3>

              <a
                href={qrCode}
                download={`FGH_${type.toUpperCase()}-QR-CODE.WEBP`}
              >
                <img
                  className="fgh-qrcode fgh-qr-pic"
                  src={qrCode}
                  alt={`${title} QR Code`}
                />
                <button
                  type="button"
                  className="contact-download fgh-download-contact"
                >
                  Download
                </button>
              </a>

              <p>{content}</p>
            </div>
          ))}
        </div>

        <button className="contact-close fgh-close" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  )
}
